import React from 'react'
import { Link } from 'react-router-dom'
import Dropdown from './Dropdown.jsx'
import '../App.css';
import image from '../images/Foodies.png'
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';

function Navbar(props) {
  const [dropbtn, setDropdown] = React.useState(false)
  const [navbar, setNavbar] = React.useState(true)
  const [drop, setDrop] = React.useState(false);

  const handleClick = () => {setDrop(!drop)}
  const scrollTop = () => { window.scrollTo({ top: 0, behavior: 'smooth' }) }

  const onMouseEnter = () => {
    if (window.innerWidth < 960) {
      setDropdown(false);
    } else {
      setDropdown(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth < 960) {
      setDropdown(false);
    } else {
      setDropdown(false);
    }
  };




  return (
    <>
      <nav className={navbar ? 'navbar active' : 'navbar'}>
        <Link to="/" className="main-link link">
          <img src={image} alt="" className="logo-img" />
        </Link>

        <ul className="links">
          <li className="inner-link">
            <Link to="/" onClick={scrollTop} className="main-link1 link">
              Home
            </Link>
          </li>
          <li className="link-2" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <Link className="main-link2 link">
              Our Features <i className={dropbtn ? "fas fa-caret-up" : "fas fa-caret-down"} />
            </Link>
            {dropbtn && <Dropdown ref1={props.ref1} ref2={props.ref2} ref3={props.ref3} />}
          </li>

          <li className="inner-link">
            <Link className="main-link3 link">
              Contact
            </Link>
          </li>
        </ul>

        <ul className="social-links">
          <li>
            <InstagramIcon style={{ fontSize: '30' }} />
          </li>

          <li >
            <FacebookIcon style={{ fontSize: '30' }} />
          </li>
        </ul>
        <div className="menu-icon" onClick={handleClick}>
          <i className='fas fa-bars' > </i>
        </div>
      </nav>

      <div className = "mobile-dropdown" style = {drop === false ? {top: '-100%'} : {top: '0'}}>
        <ul className = "mobile-items">
          <li>
            <Link className = "mobile-links" onClick = {() => props.ref3.current.scrollIntoView({behavior: 'smooth'})}> What is We'll Meal </Link> 
          </li>
          <li>
            <Link className = "mobile-links" onClick = {() => props.ref1.current.scrollIntoView({behavior: 'smooth'})}> Meal Buddy </Link> 
          </li>
          <li>
            <Link className = "mobile-links" onClick = {() => props.ref2.current.scrollIntoView({behavior: 'smooth'})}> Recipe Jackpot </Link> 
          </li>
          <li>
            <Link className = "mobile-links"> Social Media</Link> 
          </li>
        </ul>
      </div>
    </>
  )
}

export default Navbar
